<template>
  <div>
    <dv-scroll-board
      :config="config"
      style="width: 100%; height: 200px; color: #b9b9b9"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {
        columnWidth: [260, 120, 100],
        oddRowBGC: 'rgba(0,0,0,0)',
        evenRowBGC: 'rgba(229,168,189,.07)',
        data: [
          ['合肥新广地农业发展有限公司', '张忠凤,夏登华', '2024-03-29', '合格'],
          ['长丰县岗集镇寿丰家庭农场', '夏登华,周宏林', '2024-03-28', '合格'],
          ['长丰县雨顺农业专业合作社', '夏登华,周宏林', '2024-03-28', '合格'],
          ['合把秋丰种植专业合作社', '周宏林,夏登华', '2024-03-27', '合格'],
          [
            '安徽田源优品电子商务有限公司',
            '夏登华,周宏林',
            '2024-03-24',
            '合格',
          ],
          [
            '合肥青峰岭有机富硒果蔬专业合作社',
            '夏登华,周宏林',
            '2024-03-24',
            '合格',
          ],
          ['长丰县岗集镇丰泰蔬果农场', '夏登华,周宏林', '2024-03-23', '合格'],
          [
            '安徽五彩佳美现代农业有限公司',
            '夏登华,周宏林',
            '2024-03-22',
            '合格',
          ],
          ['安徽省顺源农业有限公司', '周宏林,夏登华', '2024-03-22', '合格'],
          ['安徽花果山农业科技有限公司', '张书虎,孙锐', '2024-03-18', '合格'],
        ],
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/quality-zone/detect-record-scroll.vue